import React from 'react'
import { useLocalstorageState } from 'rooks'

const enum LocalConstants {
  XYPortraitKey = 'skyvideo:position_portrait',
  XYLandscapeKey = 'skyvideo:position_landscape',
  WidthLandscapeKey = 'skyvideo:width_landscape',
  WidthPortraitKey = 'skyvideo:width_portrait',
}

export const usePlayerState = (orientation: 'landscape' | 'portrait') => {
  const isLandscape = orientation === 'landscape'

  const [position, setPosition] = useLocalstorageState(
    isLandscape ? LocalConstants.XYLandscapeKey : LocalConstants.XYPortraitKey,
    { x: 0, y: 0 }
  )
  const [width, setWidth] = useLocalstorageState(
    isLandscape ? LocalConstants.WidthLandscapeKey : LocalConstants.WidthPortraitKey,
    'auto'
  )

  const handleSetPosition = React.useCallback(
    (state: { x: number; y: number } | 'RESET') => {
      setPosition(state === 'RESET' ? { x: 0, y: 0 } : state)
    },
    [setPosition]
  )

  const handleSetWidth = React.useCallback(
    (state: string | 'RESET') => {
      setWidth(state === 'RESET' ? 'auto' : state)
    },
    [setWidth]
  )

  return { position, width, handleSetPosition, handleSetWidth, orientation }
}
